// extracted by mini-css-extract-plugin
export default {"row":"M7T3SbxNOPAnJroIe4Zq"};